
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faChartArea, faChartBar, faChartLine, faFlagUsa, faFolderOpen, faGlobeEurope, faPaperclip, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { faAngular, faBootstrap, faReact, faVuejs  } from "@fortawesome/free-brands-svg-icons";
import { Col, Row, Card, Image, Button, ListGroup, ProgressBar } from '@themesberg/react-bootstrap';

import {  faUser } from "@fortawesome/free-solid-svg-icons";




import { useTranslation } from "react-i18next";

export const ChoosePhotoWidget = ({ title, photo, onFileSelect }) => {
   const { t } = useTranslation();
  const avatarStyle = {
    width: "100px", // adjust based on .xl-avatar size
    height: "75px",
    borderRadius: "50%",
    backgroundColor: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "36px",
    fontWeight: "bold",
    color: "#555",
    overflow: "hidden"
  };

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">{title}</h5>
        <div className="d-xl-flex align-items-center">
          <div className="user-avatar xl-avatar" style={avatarStyle}>
            {photo ? (
              <Image
                fluid
                roundedCircle
                src={photo}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <span>
                <FontAwesomeIcon icon={faUser} size="lg" />
              </span>
            )}
          </div>

          <div className="file-field">
            <div className="d-flex justify-content-xl-center ms-xl-3">
              <div className="d-flex">
                <span className="icon icon-md">
                  <FontAwesomeIcon icon={faPaperclip} className="me-3" />
                </span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => {
                    if (e.target.files && e.target.files[0]) {
                      onFileSelect(e.target.files[0]);
                    }
                  }}
                />
                <div className="d-md-block text-start">
                  <div className="fw-normal text-dark mb-1">{t("profilePageTranslations.chooseImageLabel")}</div>
                  <div className="text-gray small">
                   {t("profilePageTranslations.chooseImageDescription")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};


export const CounterWidget = (props) => {
  const { icon, iconColor, category, title, period, percentage } = props;
  const percentageIcon = percentage < 0 ? faAngleDown : faAngleUp;
  const percentageColor = percentage < 0 ? "text-danger" : "text-success";

  return (
   <Card border="light" className="shadow-sm">
  <Card.Body className="text-center pb-4">
    <div className={`icon icon-shape icon-md icon-${iconColor} rounded mb-1 mx-auto`}>
      <FontAwesomeIcon icon={icon} />
    </div>
    <h5>{category}</h5>
    <h3 className="mb-1">{title}</h3>
    {/* <small>
      {period}, <FontAwesomeIcon icon={faGlobeEurope} size="xs" /> WorldWide
    </small> */}
    {/* <div className="small mt-2">
      <FontAwesomeIcon icon={percentageIcon} className={`${percentageColor} me-1`} />
      <span className={`${percentageColor} fw-bold`}>
        {percentage}%
      </span>{" "}
      Since last month
    </div> */}
  </Card.Body>
</Card>

  );
};


